import apiClient from './api';

export interface MiniProgramStaffSupportFaqItem {
  question: string;
  answer: string;
  sort: number;
}

export interface MiniProgramStaffConfig {
  id?: string;
  loginLogo: string;
  loginLogoFileId: string;
  supportPhone: string;
  supportWechat: string;
  supportHelpText: string;
  supportFaqs: MiniProgramStaffSupportFaqItem[];
  loginAgreement: string;
  privacyPolicy: string;
  orderTakingAgreement: string;
  orderTakingAgreementFileId: string;
  securityDepositAgreement: string;
  securityDepositAgreementFileId: string;
  enabled: boolean;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
}

export const getMiniProgramStaffConfig = () =>
  apiClient.get<MiniProgramStaffConfig>('/mini-program-staff-config');

export const saveMiniProgramStaffConfig = (data: MiniProgramStaffConfig) =>
  apiClient.put<MiniProgramStaffConfig>('/mini-program-staff-config', data);
